import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type UseDisciplineListQueryParams = Exclude<
  Parameters<typeof SSF.api.resultsRankingDisciplineList>[0],
  undefined
>;

const keys = createQueryKeySet<UseDisciplineListQueryParams>('disciplines');

export function useDisciplineListQuery(params?: UseDisciplineListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.resultsRankingDisciplineList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
